import React, { useEffect, useState } from 'react';
import {
    Badge,
    Box,
    ClickAwayListener,
    Grow,
    ListItemIcon,
    MenuItem,
    MenuList,
    Paper,
    Popper
} from "@material-ui/core";
import NotificationsIcon from "@material-ui/icons/Notifications";
import IconButton from "@material-ui/core/IconButton";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
    fetchNotificationPaging,
    getNotificationCount,
    reduceUpdateNotifications,
} from "../../store/slices/notification";
import * as _ from 'lodash';
import AppUtil from "../../utilities/AppUtil";
import { makeStyles } from "@material-ui/core/styles";
import { NOTIFICATION_TYPES, SYSTEM_ROLE } from "../../config/AppConfig";
import { useHistory } from "react-router-dom";
import { Autorenew, NotificationsOff } from "@material-ui/icons";
import { getAuthInfo } from "../../store/slices/auth";
import classNames from 'classnames';
import AppColor from "../../utilities/AppColor";
import PropTypes from 'prop-types';
// import { useMedia } from 'react-use';
import RoomIcon from '@material-ui/icons/Room';
import AppExtendTimeDialog from 'components/Dialog/AppExtendTimeDialog';


const Notification = (props) => {

    const { mobileOpen, isMobile } = props;
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const useStyle = makeStyles(() => ({
        itemText: {
            whiteSpace: 'break-spaces',
            borderBottom: '1px solid rgba(0, 0, 0, 0.2)'
        },
        unseen: {
            backgroundColor: AppColor.notificationBg
        },
        iconButton: {
            padding: '0 12px',
            '& .MuiSvgIcon-root': {
                height: isMobile ? '1em' : '1em',
                width: isMobile ? '1em' : '1em'
            }
        },
        menuItem: {
            display: 'flex',
            flexDirection: "column",
            alignItems: 'flex-start'
        },
        mapLink: {
            display: 'flex',
            alignItems: 'center',
            '& .MuiSvgIcon-root': {
                marginRight: '4px'
            }
        }
    }))
    const classes = useStyle();
    const history = useHistory();
    // const below768 = useMedia('(max-width: 950px)');
    const user = useSelector(getAuthInfo);
    const notificationCount = useSelector(getNotificationCount);
    const [count, setCount] = useState(notificationCount);
    const [data, setData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [queries, setQueries] = useState({
        pageNumber: 1,
        pageSize: 20
    })
    const [open, setOpen] = useState(null);
    const [initialized, setInitialized] = useState(false);
    const [extendBookingDialog, setExtendBookingDialog] = useState(false);
    const [currentNotification, setCurrentNotification] = useState(null);

    const _onToggleClick = async (event) => {
        if (Boolean(open)) {
            setOpen(null);
        } else {
            !initialized && setInitialized(true);
            setOpen(event.currentTarget);
            await _loadData({
                ...queries,
                pageNumber: 1
            });
            _updateNotifications(data, true);
        }
    }

    const _loadData = async (queries) => {
        const { payload } = await dispatch(fetchNotificationPaging(queries));
        if (payload) {
            if (queries.pageNumber === 1) {
                setData(payload.notifications);
            } else {
                setData(_.unionBy(data, payload.notifications, 'id'));
            }
            setQueries(queries);
            setTotalPages(payload.totalPages);
            _updateNotifications(payload.notifications);
        }
        return payload;
    }

    const _handleClose = () => {
        setOpen(null);
        _loadData(queries);
    }

    const _handleCloseNotification = () => {
        setExtendBookingDialog(false);
        setCurrentNotification(null);
    }

    const _onItemPress = (type, content) => {
        switch (type) {
            case NOTIFICATION_TYPES.BOOKING:
            case NOTIFICATION_TYPES.WORKER_POINT:
            case NOTIFICATION_TYPES.RATING:
            case NOTIFICATION_TYPES.NEAR_START_BOOKING:
                {
                    if (user.role === SYSTEM_ROLE.COMPANY) {
                        if (content?.bookingIds?.split(',')?.length > 1) {
                            history.push(`/admin/booking`);
                            break;
                        }
                        if (!content?.bookingIds) {
                            break;
                        }
                        history.push(`/admin/booking/${content.bookingIds}`);
                    } else
                        history.push(`/booking/${content.bookingId}`);
                    break;
                }
            case NOTIFICATION_TYPES.NDIS_WORKER_SCREENING_EXPIRE:
            case NOTIFICATION_TYPES.FIRST_AID_AND_CPR_EXPIRE:
                {
                    if (content?.workerId) {
                        if (user.role === SYSTEM_ROLE.COMPANY) {
                            history.push(`/admin/workers/${content.workerId}`);
                        } else {
                            history.push(`/workers/${content.workerId}`);
                        }
                    }
                    break;
                }
            case NOTIFICATION_TYPES.EXTEND_BOOKING_TIME_REQUEST:
                setCurrentNotification({
                    bookingId: content.bookingId,
                });
                setExtendBookingDialog(true);
                break;
            case NOTIFICATION_TYPES.BILLING:
                {
                    history.push(`/billing/${content.id}`);
                    break;
                }
            case NOTIFICATION_TYPES.COORD_PARTICIPANT:
                {
                    if (user.role === SYSTEM_ROLE.COMPANY) {
                        history.push(`/admin/clients/${content.clientId}`);
                    } else
                        history.push(`/clients/${content.clientId}`);
                    break;
                }
            case NOTIFICATION_TYPES.ON_BOARD:
                {
                    if (user.role === SYSTEM_ROLE.COMPANY) {
                        if (content.role === SYSTEM_ROLE.PARTICIPANT
                            || content.role === SYSTEM_ROLE.COORDINATOR_OTHER
                            || content.role === SYSTEM_ROLE.COORDINATOR_ADMIN
                            || content.role === SYSTEM_ROLE.HOSPITAL_ADMIN
                            || content.role === SYSTEM_ROLE.HOSPITAL_OTHER
                        ) {
                            history.push(`/admin/clients/${content.clientId}`);
                        } else {
                            history.push(`/admin/workers/${content.workerId}`);
                        }
                    } else if (user.role === SYSTEM_ROLE.SUPER_ADMIN || user.role === SYSTEM_ROLE.MANAGER) {
                        history.push(`/admin/company/detail/${content.companyId}`);
                    } else
                        history.push(`/clients/${content.clientId}`);
                    break;
                }
            case NOTIFICATION_TYPES.JOB: {
                if (user.role === SYSTEM_ROLE.COMPANY) {
                    history.push(`/admin/jobs/detail/${content.id}`);
                } else {
                    history.push(`/jobs/detail/${content.id}`);
                }
                break;
            }
            case NOTIFICATION_TYPES.PROCESS_NOTE_CREATED:
            case NOTIFICATION_TYPES.PROCESS_NOTE_RESUBMITTED: {
                if (user.role === SYSTEM_ROLE.COMPANY) {
                    history.push(`/admin/participants/${content.clientId}`);
                }
                break;
            }
            case NOTIFICATION_TYPES.PROCESS_NOTE_RESUBMISSION_REQUEST: {
                // do nothing for worker
                break;
            }
            case NOTIFICATION_TYPES.INTAKE_LINK_SUBMITTED: {
                if (user.role === SYSTEM_ROLE.COMPANY) {
                    history.push(`/admin/participants/${content.clientId}`);
                }
                break;
            }
            case NOTIFICATION_TYPES.INCIDENT_NOTIFIABLE: {
                if (user.role === SYSTEM_ROLE.COMPANY) {
                    history.push(`/admin/incidents/${content.incidentId}`);
                }
                break;
            }
        }
        _handleClose();
    }

    const _updateNotifications = async (list = [], toggle = false) => {
        if (!Array.isArray(list) || (!toggle && !Boolean(open))) return;
        // console.log('UPDATES')
        const toUpdates = list.filter(item => !item.seen);
        if (toUpdates.length > 0) {
            dispatch(reduceUpdateNotifications({
                ids: toUpdates.map(item => item.id)
            }))
        }
    }

    useEffect(() => {
        _loadData(queries);
    }, [history.location.pathname])

    useEffect(() => {
        setCount(notificationCount);
    }, [notificationCount])

    // useEffect(() => {
    //     if (initialized) {
    //         _updateNotifications(data)
    //     }
    // }, [data])

    const handleOpenMap = (content) => {
        console.log('content', content);
        const distance = AppUtil.getDistance(content.startBookingLat, content.startBookingLng, content.jobLat, content.jobLng);
        console.log(`Distance: ${distance.toFixed(2)} km`);
        // console.log('test distance', distance);
        window.open(`https://www.google.com/maps/dir/${content.startBookingLat},${content.startBookingLng}/${content.jobLat},${content.jobLng}`, "_blank");
    }

    return (
        <Box>
            <IconButton
                onClick={_onToggleClick}
                aria-label="notifications"
                aria-controls="long-menu"
                aria-haspopup="true"
                className={classes.iconButton}
                disabled={mobileOpen && isMobile}
            >
                <Badge
                    badgeContent={count}
                    color="secondary"
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    overlap="rectangular"
                >
                    <NotificationsIcon />
                </Badge>
            </IconButton>
            <Popper
                open={Boolean(open)}
                anchorEl={open}
                role={undefined}
                transition
                disablePortal
                placement="bottom-end"
            >
                {({ TransitionProps, placement }) => (
                    <Grow
                        {...TransitionProps}
                        style={{
                            transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
                        }}
                    >
                        <Paper
                            style={{
                                maxHeight: '450px',
                                width: '450px',
                                overflowY: 'scroll'
                            }}
                            elevation={10}
                        >
                            <ClickAwayListener onClickAway={_handleClose}>
                                <MenuList autoFocusItem={Boolean(open)} id="menu-list-grow">
                                    {data.length === 0 && (
                                        <MenuItem
                                            className={classes.loadMore}
                                        >
                                            <ListItemIcon>
                                                <NotificationsOff fontSize="small" />
                                            </ListItemIcon>
                                            {t('label.no_notifications')}
                                        </MenuItem>
                                    )}
                                    {data.map((item, index) => {
                                        let content = AppUtil.toCamelCaseKey(JSON.parse(item?.content));
                                        return (
                                            <MenuItem
                                                key={index}
                                                onClick={() => _onItemPress(item.notifyType, content)}
                                                className={classNames({
                                                    [classes.itemText]: true,
                                                    [classes.unseen]: !item.seen,
                                                    [classes.menuItem]: true
                                                })}
                                            >
                                                <div style={{ width: '100%' }}>
                                                    <p>{AppUtil.getNotificationMessage(item.notifyType, content, user.role)}</p>
                                                    {content.bookingStatus === 'ON_GOING' && item.notifyType === 'BOOKING' &&
                                                        <p
                                                            style={{ color: '#007bff', display: 'flex', cursor: 'pointer' }}
                                                            className={classes.mapLink} onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleOpenMap(content);
                                                            }}>
                                                            <RoomIcon />
                                                            <span>View Map</span>
                                                        </p>
                                                    }
                                                </div>
                                            </MenuItem>
                                        )
                                    })}
                                    {totalPages > queries.pageNumber && (
                                        <MenuItem
                                            onClick={() => _loadData({
                                                ...queries,
                                                pageNumber: queries.pageNumber + 1
                                            })}
                                            className={classes.loadMore}
                                        >
                                            <ListItemIcon>
                                                <Autorenew fontSize="small" />
                                            </ListItemIcon>
                                            {t('label.load_more')}
                                        </MenuItem>
                                    )}
                                </MenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>
            <AppExtendTimeDialog
                open={extendBookingDialog}
                bookingId={currentNotification?.bookingId}
                onClose={_handleCloseNotification}
            />
        </Box>
    )
}

Notification.propTypes = {
    mobileOpen: PropTypes.bool,
    isMobile: PropTypes.bool
}

export default Notification;
